import React from "react";
import {
  XMarkIcon,
  CheckIcon,
  LockClosedIcon,
} from "@heroicons/react/24/solid";

// Presentational upgrade popup. All state/actions live in UpgradeContext.
const UpgradeModal = ({
  feature,
  tierLabel,
  priceHint,
  bullets = [],
  busy,
  onUpgrade,
  onSeeAll,
  onClose,
}) => {
  if (!feature) return null;
  const { title, body } = feature.modalCopy || {};

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 animate-fadeIn">
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md rounded-2xl bg-white dark:bg-[#0f1624] border border-gray-200 dark:border-white/10 shadow-2xl p-6">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 dark:hover:text-white transition-colors"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>

        <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-gradient-to-br from-indigo-500/15 via-blue-500/15 to-purple-500/15 mb-4">
          <LockClosedIcon className="w-5 h-5 text-indigo-500" />
        </div>

        <h3 className="text-xl font-bold text-gray-900 dark:text-white">
          {title}
        </h3>
        {body && (
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 leading-relaxed">
            {body}
          </p>
        )}

        {bullets.length > 0 && (
          <ul className="mt-5 space-y-2">
            {bullets.slice(0, 5).map((b, i) => (
              <li key={i} className="flex items-start gap-2 text-sm">
                <CheckIcon className="w-4 h-4 mt-0.5 text-emerald-500 shrink-0" />
                <span className="text-gray-700 dark:text-gray-300">{b}</span>
              </li>
            ))}
          </ul>
        )}

        {priceHint && (
          <p className="mt-4 text-xs font-semibold text-emerald-500">
            {priceHint}
          </p>
        )}

        <button
          type="button"
          onClick={onUpgrade}
          disabled={busy}
          className="mt-5 w-full px-4 py-2.5 rounded-xl bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-500 transition-colors disabled:opacity-60 disabled:cursor-wait"
        >
          {busy ? "Upgrading…" : `Upgrade to ${tierLabel} — free`}
        </button>

        <div className="mt-3 flex items-center justify-center gap-4 text-xs">
          <button
            type="button"
            onClick={onSeeAll}
            className="text-indigo-500 hover:underline font-semibold"
          >
            See all plans
          </button>
          <span className="text-gray-300 dark:text-white/15">·</span>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
